import { atom } from "recoil";

export const openedLabelIdState = atom<string | undefined>({
  key: "openedLabelIdState",
  default: undefined,
});
